import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PartnerStatsApi from '../../api/partners/StatsApi'
import LoadingAnimation from '../shared/LoadingAnimation.js'
import { camelify } from '../../decorators/textTools'

const StatsModule = ({ partner }) => {
  const { t } = useTranslation()
  const [partnerStats, setPartnerStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!partner?.slug) return
    setLoading(true)
    PartnerStatsApi.getAll(partner.slug).then((res) => {
      if (res.response?.ok) {
        setPartnerStats(camelify(res.json))
      }
      setLoading(false)
    })
  }, [partner?.slug])

  if (partner == null) return null
  if (loading || !partnerStats) {
    return <LoadingAnimation size={40} thickness={2} />
  }

  const { parentConversations, parentAttendees, pastConversations, activeConversations, attendees } = partnerStats
  const { location } = partner

  const cookedPastConversations = () => {
    switch (partner.id) {
      case 1:
        return pastConversations + 20
      case 22:
        return pastConversations + 8
      default:
        return pastConversations
    }
  }

  const cookedAttendeeCount = () => {
    switch (partner.id) {
      case 1:
        return attendees + 220
      case 22:
        return attendees + 100
      default:
        return attendees
    }
  }

  const globalStats = () => {
    if (global.coco) {
      return (
        <div>
          <div className='row no-gutters thin-bottom middle-xs fat-top'>
            <div className='col-xs-4 align-right'>
              <i className='fal fa-globe header-24 opacity-8' />
            </div>
            <div className='col-xs-8 no-right-gutter no-left-gutter weak-underline-sm tiny-bottom-padding'>{t('common.global')}</div>
          </div>

          <div className='row no-gutters thin-bottom reg-top'>
            <div className='col-xs-4 align-right'>{parentConversations}</div>
            <div className='col-xs-8 no-right-gutter no-left-gutter'>{t('partners.topics')}</div>
          </div>
          <div className='row no-gutters thin-bottom'>
            <div className='col-xs-4 align-right'>{parentAttendees}</div>
            <div className='col-xs-8 no-right-gutter no-left-gutter'>{t('partners.attendees')}</div>
          </div>
        </div>
      )
    }
  }

  return (
    <div>
      <div className='counter-table header-22 width-240-sm center-margin fat-top-padding'>
        <div className='row no-gutters thin-bottom middle-xs'>
          <div className='col-xs-4 align-right'>
            <i className='fal fa-map-marker-alt header-24 opacity-8' />
          </div>
          <div className='col-xs-8 no-right-gutter no-left-gutter weak-underline-sm tiny-bottom-padding'>{location}</div>
        </div>

        <div className='row no-gutters thin-bottom reg-top'>
          <div className='col-xs-4 align-right'>{cookedPastConversations()}</div>
          <div className='col-xs-8 no-right-gutter no-left-gutter'>{global.coco ? t('partners.pastTopics') : t('partners.pastConversations')}</div>
        </div>

        <div className='row no-gutters thin-bottom'>
          <div className='col-xs-4 align-right'>{activeConversations}</div>
          <div className='col-xs-8 no-right-gutter no-left-gutter'>{global.coco ? t('partners.activeTopics') : t('partners.activeConversations')}</div>
        </div>
        <div className='row no-gutters thin-bottom'>
          <div className='col-xs-4 align-right'>{cookedAttendeeCount()}</div>
          <div className='col-xs-8 no-right-gutter no-left-gutter'>{t('partners.totalAttend')}</div>
        </div>

        {globalStats()}
      </div>
    </div>
  )
}

export default StatsModule
